<template>
    <div>
     <b-modal size="xl" :id="ModalId" :visible="true" centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalEditGoals" @close="this.emitEventCancel" @ok="handleOk" :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
      
        <form ref="form_EditPriorAutho" @submit.stop.prevent="handleSubmit">
            <MdTitle v-bind:Text="$t('Shared.gInfo')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-bind:StyleProp="'margin: 0 !important;'"/>
            <b-row>
                <b-col md="12">
                    <MdCheckBox
                    v-bind:Label="$t('initialization.iinsurance.enRequired')"
                    v-bind:Name="'checkbox-Enrollment'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="EnrollmentRequired"
                    v-on:change="onChangeEnrollmentRequired"
                    v-bind:ignoreChangedEmit="false"/>
            </b-col>                        
        </b-row>
        <MdTitle v-bind:Text="$t('Shared.PriorAuthorization')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-bind:StyleProp="'margin: 0 !important;'"/>
        <b-row>
            <b-col md="12">
                <MdCheckBox
                    v-bind:Label="$t('insuranceSetup.uAuthorization')"
                    v-bind:Name="'checkbox-UsePriorAuthorization'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="UsePriorAuthorization"
                    v-on:change="onChangeUsePrior"
                    v-bind:ignoreChangedEmit="false"/>
            </b-col>                        
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12"> 
                <MdSelect
                    v-bind:Label="$t('Shared.PriorAuthorization')"
                    v-bind:Options="PriorAuthoList"
                    v-bind:FieldDescription="'description'"
                    v-bind:IsDisabled="ReadOnly"
                    v-bind:AllowEmpty="false"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="PriorAutho"                       
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownPriorAutho"/>
            </b-col>
            <b-col lg="3" md="3" sm="12"> 
                <MdSelect
                    v-bind:Label="$t('insuranceSetup.uUnitsAs')"
                    v-bind:Options="UnitsAsList"
                    v-bind:FieldDescription="'description'"
                    v-bind:IsDisabled="ReadOnly"
                    v-bind:AllowEmpty="false"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="UnitsAs"                       
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownUnits"/>
            </b-col>
            <b-col lg="3" md="3" sm="12"> 
                <MdEdit 
                    v-bind:Label="$t('insuranceSetup.uWarnMeDaysBefore')"
                    v-bind:TypeProp="'number'"                   
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:Name="'iWarnMeDaysBefore'"
                    v-model.number="warnMeBeforeEndDate"                 
                    v-bind:Id="'iwarnMeDaysBefore'"/> 
            </b-col>
            <b-col lg="3" md="3" sm="12"> 
                <MdEdit 
                    v-bind:Label="$t('insuranceSetup.WarnAllowedBy')"
                    v-bind:TypeProp="'number'"                   
                    v-bind:isReadOnly="ReadOnly"
                    v-bind:Name="'iWarnMeWhenTotalUnits'"
                    v-model.number="warnMeWhenTotalUnitsAllowed"                 
                    v-bind:Id="'iwarnMeWhenTotalUnits'"/>
            </b-col>
        </b-row>
        <b-row>
           <b-col lg="4" md="4" sm="12"> 
                 <MdCheckBox
                   v-bind:Label="$t('insuranceSetup.uDateRangeAuthorization')"
                   v-bind:Name="'checkbox-UseDateRangeForPriorAuthorization'"
                   v-bind:ClassProp="'AlignCheck'"
                   v-bind:CheckedValue="true"
                   v-bind:isReadOnly="ReadOnly"
                   v-bind:UncheckedValue="false"
                   v-model="UseDateRangeForPriorAuthorization"
                   v-bind:ignoreChangedEmit="false"/>
            </b-col>
        </b-row>
      </form>
     </b-modal>  
     
    </div>
</template>
 
 <script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import ISetup from '@/services/isetup.service'
// import { EventBus } from '@/event-bus.js';
 

 export default {
    name: 'IniModalEditPrior',   
    mixins: [ShowMessage, DBFunctions], 
    props: {
        ModalId: String,
        TitleWindow: String,
        InsuranceCode:String
    },
   
   data(){
     return {
        Load: false,
        ReadOnly:true,
        EnrollmentRequired:false,
        UsePriorAuthorization:false,
        UseDateRangeForPriorAuthorization:false,
        PriorAuthoList:[
            {code:"Y",description:"CPT's"},
            {code:"T",description:this.$t('Shared.Therapies')},
            {code:"C",description:this.$t('therapyCatListing.Title')},
            {code:"N",description:"None"}
        ],
        UnitsAsList:[
            {code:"U",description:this.$t('Shared.Units')},
            {code:"D",description:this.$t('Shared.Days')},
            {code:"N",description: this.$t('insuranceSetup.oPList.None')},
        ],
        PriorAutho:"",
        UnitsAs:"",
        warnMeBeforeEndDate:0,
        warnMeWhenTotalUnitsAllowed:0
     }
   },
 
   methods:{
    onChangeUsePrior(check){
        this.ReadOnly = !check;

        if(this.ReadOnly){
            this.PriorAutho = "";
            this.UnitsAs = "";
            this.warnMeBeforeEndDate = 0;
            this.warnMeWhenTotalUnitsAllowed = 0;
        }
    },

    handleOk($event){   
        $event.preventDefault();          
         this.UpdatePrior();
    },

    ChangeDropDownPriorAutho(item){
        this.PriorAutho = item ? item.code : "";
    },

    ChangeDropDownUnits(item){
        this.UnitsAs = item ? item.code : "";
    },

    onChangeEnrollmentRequired(){

    },

    async getInsurance(){   
      this.Load = true;
      await ISetup.GetInsurance(this.InsuranceCode)
      .then((response) => {      
           if (response.status == "200") { 
                let data = response.data;

                this.PriorAutho = data.priorAuthorizationBasedOn;
                this.UsePriorAuthorization = data.userPriorAuthorization;
                this.UnitsAs = data.useUnitsAs;
                this.warnMeBeforeEndDate = data.warnMeUnitsBeforeEndDate;
                this.warnMeWhenTotalUnitsAllowed = data.warnMeUnitsBeforeEndDate;
                this.UseDateRangeForPriorAuthorization = data.useDateRangeForPriorAuthorization;
                this.EnrollmentRequired = data.enrollmentRequired;
                this.ReadOnly = !this.UsePriorAuthorization;

               this.Load = false;
           }
           this.Load = false;
      })
      .catch(error => {
        this.Load = false;
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    async UpdatePrior(){   
      this.Load = true;
      let data = {
        UserPriorAuthorization:this.UsePriorAuthorization,
        PriorAuthorizationBasedOn:this.PriorAutho,
        UseDateRangeForPriorAuthorization:this.UseDateRangeForPriorAuthorization,
        UseUnitsAs:this.UnitsAs,
        WarnMeDayBeforeEndDate:this.warnMeBeforeEndDate,
        WarnMeUnitsBeforeEndDate:this.warnMeWhenTotalUnitsAllowed,
        EnrollmentRequired:this.EnrollmentRequired    
      }    

      await ISetup.UpdateInsurancePrior(this.InsuranceCode,data)
      .then((response) => {      
           if (response.status == "200") { 
               this.Load = false;
               setTimeout(() => this.ResetModal(), 100);
               
           }
           this.Load = false;
      })
      .catch(error => {
        this.Load = false;
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    emitEventCancel(){
         this.ResetModal();
    },

    ResetModal(){
        this.$emit('OnResetModal',true);
    },

   

     
   },
 
   mounted(){
    //await this.getWileyTxGoals();
    this.getInsurance();
   },
 };
 </script>

